/**
 *
 * PatientOverview
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { FormattedMessage, injectIntl } from "react-intl";
import ArrowButton from "basicComponents/ArrowButton/ArrowButton";
import { isIE } from "react-device-detect";
import ReactTable from "components/ReactTable/index";
import SearchTextField from "./SearchTextField";
import TableHeader from "./TableHeader";
import "react-table/react-table.css";
import "./style.css";
import GlobalMessages from "../../messages/messages";
import BuildColumns from "./Columns";
import { PADDING as BUTTON_PADDING, TableButton } from "./TableButton";
import IconActionButton from "basicComponents/IconActionButton/IconActionButton";

const BUTTON_HEIGHT = 40;
const BUTTON_WRAPPER_HEIGHT = BUTTON_HEIGHT + BUTTON_PADDING;
const HEIGHT = 150;
const FULL_HEIGHT = 500;

export class SearchV2 extends Component {
  static propTypes = {
    // STRING
    id: PropTypes.string,

    arrowId: PropTypes.string,
    noResultButtonId: PropTypes.string,

    // OBJECT
    title: PropTypes.object,
    placeholder: PropTypes.object,
    sorted: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
    iconButtonText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

    // FUNC
    onClick: PropTypes.func,
    handleArrowClicked: PropTypes.func,
    onChange: PropTypes.func,
    onIconClicked: PropTypes.func,
    handleUglyButtonClicked: PropTypes.func,
    onSortedChange: PropTypes.func,

    // ARRAY
    headers: PropTypes.array,
    items: PropTypes.array,
    icons: PropTypes.array,

    // BOOL
    Add: PropTypes.bool,
    searchIcon: PropTypes.bool,
    maxHeight: PropTypes.bool,
    showArrow: PropTypes.bool,
    showTableContent: PropTypes.bool,
    enableUglyLongButton: PropTypes.bool,
    focusTextField: PropTypes.bool,
    enableUglyLongButtonOnNoResult: PropTypes.bool,
    showPaginationBottom: PropTypes.bool,
    loading: PropTypes.bool,
    enableIcons: PropTypes.bool,
    doneTyping: PropTypes.bool,

    // NUMBER
    height: PropTypes.number,
    width: PropTypes.number,

    // ANY
    value: PropTypes.any,
    conditionalEditIcon: PropTypes.any,
    conditionalDeleteIcon: PropTypes.any,
    defaultSorted: PropTypes.any,
  };

  static defaultProps = {
    iconButtonText: <FormattedMessage {...GlobalMessages.unavailable} />,
    enableIcons: true,
    showArrow: false,
    showTableContent: false,
    searchIcon: true,
    showPaginationBottom: false,
    icons: [],
    doneTyping: true,
  };

  state = {
    selected: null,
    selectedObject: {},
    columns: [],
    isIEBrowser: false,
  };

  handleArrowClicked = event => {
    if (this.props.handleArrowClicked) {
      this.props.handleArrowClicked(event, this.state.selectedObject);
    }
  };

  componentDidMount = () => {
    this.setState({
      isIEBrowser: isIE,
      columns: BuildColumns(
        this.props.headers,
        this.props.icons,
        this.handleIconClicked,
        this.props.conditionalEditIcon,
        this.props.conditionalDeleteIcon,
        this.props.enableIcons,
      ),
    });
  };

  handleIconClicked = (iconName, value) => () => {
    if (this.props.onIconClicked) {
      this.props.onIconClicked(iconName, value);
    }
  };

  handleTrProps = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: () => {
          this.setState({
            selected: rowInfo.index,
            selectedObject: rowInfo.original,
          });
          if (this.props.onClick) {
            this.props.onClick(state, rowInfo);
          }
        },
        style: {
          backgroundColor:
            rowInfo.index === this.state.selected ? "#eeeeee" : "#ffffff",
        },
      };
    }
    return {};
  };

  handleChange = e => {
    this.props.onChange(e);
  };

  getBaseHeight() {
    let height = HEIGHT;
    if (this.props.maxHeight) {
      height = FULL_HEIGHT;
    }
    if (this.props.height !== undefined && this.props.height !== null) {
      height = this.props.height;
    }

    return height;
  }

  isButtonVisible() {
    if (this.props.enableUglyLongButton) {
      return true;
    }

    if (this.props.enableUglyLongButtonOnNoResult) {
      return (
        this.props.items &&
        this.props.items.length === 0 &&
        !this.props.loading &&
        this.props.doneTyping &&
        (this.props.value || "").length > 2
      );
    }
    return false;
  }

  render() {
    const buttonVisible = this.isButtonVisible();
    const baseHeight = this.getBaseHeight();
    return (
      <div id="overviewtable" style={{background:"white", borderRadius:"18px"}}>
        {this.props.title && <TableHeader>{this.props.title}</TableHeader>}
        <TableWrapper baseHeight={baseHeight} data-cy={this.props.id}>
          {/* search */}
          <div style={{display:'flex',justifyContent:"space-between", gap:'20px'}}>
            <div style={{minWidth:"100px",flexGrow:1}}>
              <SearchTextField
                id={this.props.id}
                showTableContent={this.props.showTableContent}
                focusTextField={this.props.focusTextField}
                keepPlaceholder={this.props.keepPlaceholder}
                width={this.props.width}
                removeBorder
                onChange={this.handleChange}
                searchIcon={this.props.searchIcon}
                placeholder={this.props.placeholder}
                value={this.props.value}
                items={this.props.items}
              />
            </div>
            <div style={{}}>
              {buttonVisible && (
                <TableButton
                  style={{flexGrow:1}}
                  customPadding
                  noResultButtonId={this.props.noResultButtonId}
                  iconButtonText={this.props.iconButtonText}
                  customHeight={`${BUTTON_HEIGHT}px`}
                  onClick={this.props.handleUglyButtonClicked}
                />
              )}
            </div>
          </div>
          {this.props.showTableContent && (
            <>
            {/* button */}
              
              <TableContainer data-cy="searchDropDown">
                <StyledReactTable
                  buttonVisible={buttonVisible}
                  enableIcons={this.props.enableIcons}
                  conditionalEditIcon={this.props.conditionalEditIcon}
                  showMoreIcon={this.props.icons.includes("show")}
                  editIcon={this.props.icons.includes("edit")}
                  Add={this.props.icons.includes("add")}
                  deleteIcon={this.props.icons.includes("delete")}
                  isIEBrowser={this.state.isIEBrowser}
                  baseHeight={baseHeight}
                  noDataText={
                    <FormattedMessage {...GlobalMessages.noDataText} />
                  }
                  columns={this.state.columns}
                  defaultSortMethod={this.defaultSortMethod}
                  data={this.props.items}
                  showPagination={this.props.showPaginationBottom}
                  resizable={false}
                  showPaginationBottom={this.props.showPaginationBottom}
                  sortable
                  minRows={0}
                  defaultPageSize={
                    this.props.items && this.props.items.length > 60
                      ? 60
                      : this.props.items && this.props.items.length
                  }
                  getTrProps={this.handleTrProps}
                  defaultSorted={this.props.defaultSorted}
                  onSortedChange={this.props.onSortedChange}
                  sorted={this.props.sorted}
                  style={{
                    height: "160px",
                  }}
                />
              </TableContainer>
            </>
          )}
        </TableWrapper>
        {this.props.showArrow && (
          <ArrowWrapper>
            <ArrowButton
              id={this.props.arrowId}
              onClick={this.handleArrowClicked}
              down
            />
          </ArrowWrapper>
        )}
      </div>
    );
  }
}

const TableWrapper = styled.div`
  ${({ baseHeight }) => `height: ${baseHeight}`};
  border: ${({ theme }) => theme.borderColor} solid 1px;
  border-radius: ${({ theme }) => theme.borderRadius};
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
`;

const TableContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius};
  overflow: hidden;
`;

const ArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

function paddingLength({ data }) {
  if (data && data.length > 3) {
    return css`
      padding-right: 5px;
    `;
  }
  return "";
}
function tableHeight({ baseHeight, buttonVisible }) {
  let height = baseHeight;
  // subtract the button height if it is visible
  if (buttonVisible) {
    height -= BUTTON_WRAPPER_HEIGHT;
  }
  return css`
    height: ${height}px !important;
  `;
}
export const StyledReactTable = styled(ReactTable)`
  ${tableHeight};
  border: 0 !important;

  .-header .rt-tr {
    ${paddingLength};
  }

  .rt-noData {
    margin-top: 17px;
  }

  .-dateIsToday div {
    &:nth-child(3) {
      &:before {
        content: "";
        background-color: ${({ theme }) => theme.green} !important;
        height: 100%;
        width: 5px;
        position: absolute;
        left: -2px;
        margin-right: 2px;
      }
    }
  }
`;

export default injectIntl(SearchV2);
